import ContentLayout from '@/layouts/content-layout'
import ArenaFormView from '@/sections/arena/view/arena-form-view'

export default function ArenaFormPage() {
  return (
    <ContentLayout title="สนามแข่งขัน" backButton>
      <ArenaFormView />
    </ContentLayout>
  )
}
